
import { Vue, Component } from "vue-property-decorator";
import { regionData } from "element-china-area-data";
import areaArr from "@/components/world.js";
@Component({
  name: "goodsDetail",
})	
export default class goodsDetail extends Vue {
	
  data() {
    return {
		data:{
			id:'',
			descr:'',
			pics:[],
			phone:'',
			brandPic:'',
			goodsCategory:'',
			place:'',
			price:'',
			deposit:'',
			total:'',
			postage:'',
			count:'',
			buyLimit:'',
			shopName:'',
			enable:'',
			approveTag:''
		},
		value: [[17,18,19],[1,7,10],[1,2,3]],
		options : regionData,
		selectedOptions:[],
		areaArr:areaArr,
		radio: '2',

		dialogVisible:false,
		dialogTitle:'',
		selectReasons:[],
		reasons:[
			'品牌存在纠纷',
			'品牌库已收入',
			'商品描述不清或违规',
			'商品图片不清晰或违规'
		],
		checkAll: false,
		isIndeterminate: true,
		textarea:'',
	}
  };
  private onCancel(){
	  
	  console.log('取消')
	  this.$router.back();
  }
  private onSubmit() {
    console.log(this.data);
  };
  private handleChange(value:any){
	  
	  console.log('ddd',value);
  };
  private handleClose(){
	// 关闭弹框
	this.dialogVisible = false;
  };
  private sureSubmit(value:any){
			  
	// 确认弹框
	this.dialogVisible = false;
	this.checkError(value);
  };
  private handleReasonsChange(value:any){
			  
	//审核原因
	let checkedCount = value.length;
	this.checkAll = checkedCount === this.reasons.length;
	this.isIndeterminate = checkedCount > 0 && checkedCount < this.reasons.length;
	console.log(value);
	this.selectReasons = value;
	let tempText = '';
	for (let i in this.selectReasons) {
		console.log(i); 	//打印结果为books的索引
		let integer = parseFloat(i)+ 1;
		tempText += integer+'.'+this.selectReasons[i]+',';
	}
	this.textarea = tempText;

   };
  // 审核通过
  private checkSuccess(value:any) {

	console.log(value);
	let idTemp = this.$route.query.id;
	let resData = {
		'approveReason' : this.textarea,
		'approveTag' : 1
	};
	let paramter = {
		'id':idTemp,
		'approveDto':resData
	};
	this.$http.post("taste/approve/"+idTemp, resData).then((res: any) => {
		
		let tempData = res.data.data;
		this.$message({
          message: '审核成功',
          type: 'success'
        });
		this.dialogVisible = false;
		window.location.reload();
	});
  };
  // 审核不通过
  private checkError(value:any) {

	let idTemp = this.$route.query.id;
	let resData = {
		'approveReason' : this.textarea,
		'approveTag' : 0
	};
	let paramter = {
		'id':idTemp,
		'approveDto':resData
	};
	this.$http.post("taste/approve/"+idTemp, paramter).then((res: any) => {
		let tempData = res.data.data;
		console.log('radio',tempData);
		this.dialogVisible = false;
		window.location.reload();
	});
  };
  private mounted(){
	  
	let tempData:any = {};
	let id = this.$route.query.id;
	this.$http.get("taste/"+id, {}).then((res: any) => {
		tempData = res.data.data;
		this.data = tempData;
		/*
		this.data = {
			id:tempData.id,
			descr:tempData.descr,
			pics:tempData.pics,
			phone:tempData.phone,
			brandPic:'',
			goodsCategory:'',
			place:tempData.place,
			price:tempData.price,
			deposit:tempData.deposit,
			total:tempData.total,
			postage:tempData.postage,
			count:tempData.count,
			buyLimit:tempData.buyLimit,
			shopName:tempData.shopName,
			enable:tempData.enable,
			approveTag:tempData.approveTag
		};
		*/
		console.log('radio',tempData);
	});
  }
}
	
